import type { PayloadAction } from '@luna/state';
import { createSharedSlice } from '@luna/state';

import { SESSION_STORAGE_KEYS } from './constants';
import type { RequestsCounterOptions } from './types';

/**
 * Options are a singleton which can be modified
 * while the observable is alive to immediately change the
 * behaviour without recreating an observable.
 * */

export const useRequestsCounterOptions = createSharedSlice({
    initialState: {
        toggled: sessionStorage.getItem(SESSION_STORAGE_KEYS.TOGGLED) === 'on',
        onlyRepeatedCalls:
            sessionStorage.getItem(SESSION_STORAGE_KEYS.ONLY_REPEATED_CALLS) === 'true',
        filterBy: sessionStorage.getItem(SESSION_STORAGE_KEYS.FILTER_TYPE) ?? 'all',
        searchFor: sessionStorage.getItem(SESSION_STORAGE_KEYS.SEARCH_FOR) ?? '',
    } as RequestsCounterOptions,
    reducers: {
        setOptions: (
            state,
            {
                payload: { toggled, onlyRepeatedCalls, filterBy, searchFor },
            }: PayloadAction<Partial<RequestsCounterOptions>>,
        ) => {
            state.toggled = toggled ?? state.toggled;
            if (state.toggled) {
                sessionStorage.setItem(SESSION_STORAGE_KEYS.TOGGLED, 'on');
            } else {
                sessionStorage.removeItem(SESSION_STORAGE_KEYS.TOGGLED);
            }

            state.onlyRepeatedCalls = onlyRepeatedCalls ?? state.onlyRepeatedCalls;
            if (state.onlyRepeatedCalls) {
                sessionStorage.setItem(SESSION_STORAGE_KEYS.ONLY_REPEATED_CALLS, 'true');
            } else {
                sessionStorage.removeItem(SESSION_STORAGE_KEYS.ONLY_REPEATED_CALLS);
            }

            state.filterBy = filterBy ?? state.filterBy;
            sessionStorage.setItem(SESSION_STORAGE_KEYS.FILTER_TYPE, state.filterBy);

            state.searchFor = searchFor ?? state.searchFor;
            sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_FOR, state.searchFor);
        },
    },
});
